import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService} from '../data.service';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import { Trasllat } from '../lib/model/trasllat';
import { Universitat } from '../lib/model/universitat';
import { Pais } from '../lib/model/pais';
import { IValue } from '../lib/model/ivalue';
import { Estudi } from '../lib/model/estudi';
import { Utilitats } from '../lib/utilitats';
import { HttpClient } from '@angular/common/http';
import { BLEstudi } from '../lib/bl/blestudi';
import { BLTrasllat } from '../lib/bl/bltrasllat';
import { DocumentPreinscripcio } from '../lib/model/documentPreinscripcio';
import { MatStepper, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-estudis',
  templateUrl: './estudis.component.html',
  styleUrls: ['./estudis.component.css'],
  providers: [BLEstudi, BLTrasllat]
})
export class EstudisComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;
  notaMitjanaInput = new FormControl('', [Validators.max(10), Validators.min(0)]);

  inicialitzat = false;
  dataService: DataService;
  trasllat: Trasllat;
  stepPerformed = false;

  paisCtrl: FormControl;
  universitatCtrl: FormControl;
  estudisCtrl: FormControl;

  filteredPaisos: Observable<Pais[]>;
  filteredUniversitats: Observable<Universitat[]>;
  filteredEstudis: Observable<Estudi[]>;

  estudis: Estudi[] = new Array<Estudi>();

  constructor(  dataService: DataService,
                private http: HttpClient,
                public utilitats: Utilitats,
                private blestudi: BLEstudi,
                private blTrasllat: BLTrasllat,
                public snackBar: MatSnackBar) {

    this.dataService = dataService;
    this.trasllat = this.dataService.trasllat;

    this.paisCtrl = new FormControl();
    this.filteredPaisos = this.paisCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.dataService.filtraPaisos(x) : this.dataService.paisos);

    this.universitatCtrl = new FormControl();
    this.filteredUniversitats = this.universitatCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.dataService.filtraUniversitats(x) : this.dataService.universitats);

    this.estudisCtrl = new FormControl();
    this.setFilteredEstudis();
  }

  async ngOnInit() {
    await this.loadEstudis();
    this.inicialitzat = true;
  }

  filtraEstudis(x): Estudi[] {
    const z = this;
    return this.estudis.filter(function(y) {
      const x1 = z.dataService.normalize(z.utilitats.getString(x).toLowerCase());
      const y1 = z.dataService.normalize(y.name.toLowerCase());
      return y1.includes(x1);
    });
  }

  setFilteredEstudis() {
    this.filteredEstudis = this.estudisCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.filtraEstudis(x) : this.estudis);
  }

  async loadEstudis() {
    this.estudis = new Array<Estudi>();
    const estudiRealitzat = this.trasllat.estudiRealitzat;
    if (this.inicialitzat) {
      estudiRealitzat.estudi = null;
    }
    this.estudis = await this.blestudi.list(
      estudiRealitzat.pais,
      estudiRealitzat.universitat,
      this.trasllat.alumne,
      this.dataService.current_language);
    this.setFilteredEstudis();
  }

  async loadDocuments() {
    const documents = await this.blTrasllat.getDocuments(this.trasllat);
    this.trasllat.documents = new Array<DocumentPreinscripcio>();
    Object.assign(this.trasllat.documents, documents);
  }

  async paisChange(newValue) {
    try {
      if (newValue != null && newValue.value) {
        const estudiRealitzat = this.trasllat.estudiRealitzat;
        if ((estudiRealitzat.pais === null) ||
            (estudiRealitzat.pais.value !== newValue.value)) {
          estudiRealitzat.pais = newValue;
          await this.loadEstudis();
          await this.loadDocuments();
        }
      } else {
        this.trasllat.estudiRealitzat.pais = null;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async universitatChange(newValue) {
    try {
      if (newValue != null && newValue.value) {
        const estudiRealitzat = this.trasllat.estudiRealitzat;
        if ((estudiRealitzat.universitat === null) ||
            (estudiRealitzat.universitat.value !== newValue.value)) {
          this.trasllat.estudiRealitzat.universitat = newValue;
          await this.loadEstudis();
          await this.loadDocuments();
        }
      } else {
        this.trasllat.estudiRealitzat.universitat = null;
      }
    } catch (err) {
      console.log(err);
    }
  }

  estudiChange(newValue) {
    try {
      if (newValue != null && newValue.value) {
        const estudiRealitzat = this.trasllat.estudiRealitzat;
        if ((estudiRealitzat.estudi === null) ||
            (estudiRealitzat.estudi.value !== newValue.value)) {
          this.trasllat.estudiRealitzat.estudi = newValue;
        }
      } else {
          this.trasllat.estudiRealitzat.estudi = null;
      }
    } catch (err) {
      console.log(err);
    }
  }

  nombreColumnes(): number {    
    return 3;
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
      // TODO: Tenim una barreja de dos estils, template driven i reactive driven, per això cal validar algunes coses a banda
      if (this.notaMitjanaInput.invalid) {
        return false;
      }
      const estudiRealitzat = this.trasllat.estudiRealitzat;
      if (estudiRealitzat.pais == null) {
          return false;
      }
      if (estudiRealitzat.universitat == null && this.utilitats.isNullOrEmpty(estudiRealitzat.universitatText)) {
          return false;
      }
      if (estudiRealitzat.estudi == null && this.utilitats.isNullOrEmpty(estudiRealitzat.estudiText)) {
          return false;
      }
      if (estudiRealitzat.swAssabentatIdioma == null || !estudiRealitzat.swAssabentatIdioma) {
          return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

  public async continua() {
    try {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
      if (!this.trasllat.isnew) {
        this.trasllat = await this.blTrasllat.save(this.trasllat);
        this.dataService.trasllat = this.trasllat;
      }
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/estudis/estudis.component.ts